var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import { useToastStack } from "./ToastStack";
import { ToastVisual } from "./ToastVisual";
var defaultTimeout = {
    default: 0,
    success: 5,
    warning: 0,
    error: 0
};
/**
 * The style of the container which will contain the ToastVisual.
 * This element should position the contained ToastVisual when
 * injected at the end of the document body.
 */
var ToastPortalStyle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  width: 100%;\n  bottom: 25px;\n  text-align: center;\n"], ["\n  position: fixed;\n  width: 100%;\n  bottom: 25px;\n  text-align: center;\n"])));
var Toast = function (_a) {
    var variant = _a.variant, open = _a.open, timeout = _a.timeout, portalClassName = _a.portalClassName, portalId = _a.portalId, portalStyle = _a.portalStyle, onRequestClose = _a.onRequestClose, children = _a.children, visualProps = __rest(_a, ["variant", "open", "timeout", "portalClassName", "portalId", "portalStyle", "onRequestClose", "children"]);
    if (timeout === undefined) {
        timeout = defaultTimeout[variant || "default"];
    }
    var toastStack = useToastStack();
    // We need a reference to onRequestClose to avoid restarting the timer
    //  if the function changes.  This can happen if someone calls
    //  us without using React.useCallback.
    var onRequestCloseRef = React.useRef();
    // Keep the ref up to date.
    React.useEffect(function () {
        onRequestCloseRef.current = onRequestClose;
    }, [onRequestClose]);
    // Create the timer if we open.
    //  This will restart the timer if the timeout changes.
    React.useEffect(function () {
        if (open && timeout) {
            var token_1 = setTimeout(function () {
                var onRequestClose = onRequestCloseRef.current;
                if (onRequestClose) {
                    onRequestClose();
                }
                token_1 = null;
            }, timeout * 1000);
            return function () {
                if (token_1) {
                    clearTimeout(token_1);
                }
            };
        }
    }, [open, timeout]);
    if (!open) {
        return null;
    }
    var visual = (React.createElement(ToastVisual, __assign({}, visualProps, { variant: variant, onRequestClose: onRequestClose }), children));
    if (toastStack) {
        /*
        If we have a toast stack, portal the toast visual into it.
        We do not need ToastPortalStyle  in this case as the toast stack
        is responsible for our positioning.
        */
        return createPortal(visual, toastStack);
    }
    else {
        /*
        If we do not have a toast stack, we need to make our own portal.
    
        Inject the toast by targeting the document body with a portal.
    
        This will inject the component stack as the last child
        of the body, thereby placing it last in the natural tab order.
    
        The ToastPortalStyle is responsible for positioning the ToastVisual
        at the bottom center of the screen, with the ToastVisual
        containing the actual visual element of the Toast.
        */
        return createPortal(React.createElement(ToastPortalStyle, { id: portalId, className: portalClassName, style: portalStyle }, visual), document.body);
    }
};
export default Toast;
var templateObject_1;
//# sourceMappingURL=Toast.js.map